import React from 'react'
import Footer from '../components/SingleRoom/Footer/Footer'
import Payments from '../components/Payment/Payments'
import Navbar from "../components/Payment/components/Navbar/Navbar"
function Payment() {
  return (
    <>
         <Navbar />   
         <Payments/>
         <Footer/>
    </>
  )
}

export default Payment